module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/footer_17f29b.png";